var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNordicWalking = function SvgNordicWalking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "nordic_walking_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#nordic_walking_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#57565C",
    d: "m4.22 22.75 1.895-8.596h1.208L5.428 22.75zm3.106 0 2.8-14.273-2.376.96v3.313h-1.5V8.454l4.81-2.025q.705-.29 1.368-.1t1.06.806l.99 1.59q.651 1.05 1.758 1.745 1.107.693 2.514.761v1.5a6.6 6.6 0 0 1-3.006-.817 7.15 7.15 0 0 1-2.37-2.096l-.744 3.76 2.12 2.028v7.144h-1.5v-5.836l-2.504-2.394-1.858 8.23zM13.5 5.348q-.759 0-1.302-.545a1.78 1.78 0 0 1-.545-1.302q0-.758.545-1.301a1.78 1.78 0 0 1 1.301-.545q.759 0 1.303.545.544.543.544 1.301 0 .759-.544 1.302a1.78 1.78 0 0 1-1.303.545m4.153 17.403v-8.596h1.193v8.596z"
  }))));
};
export default SvgNordicWalking;